"use strict";

var LoggerInstance = require("js-logger").get("LogoutApi");

var AbstractApi = require("./AbstractApi");

var LogoutApi = class extends AbstractApi {
	logout(options) {
		return this.post({
			data: options,
			url: "/api/logout"
		});
	}
};

module.exports = new LogoutApi();
